import { render, staticRenderFns } from "./editDialog.vue?vue&type=template&id=013fe22c&scoped=true&"
import script from "./editDialog.vue?vue&type=script&lang=ts&"
export * from "./editDialog.vue?vue&type=script&lang=ts&"
import style0 from "./editDialog.vue?vue&type=style&index=0&id=013fe22c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013fe22c",
  null
  
)

export default component.exports